import styled from 'styled-components';
import Button from 'components/ui/Button';

import { colours } from 'themes/default';

export const StyledButtonContainer = styled.span`
  margin-right: 20px;
`;

export const CtaButton = styled(Button)`
  width: 100%;
  margin: ${({ isMenuOpen }) => (isMenuOpen ? '4px 0 0' : '4px 0')};
  background: ${colours.Core.CoreNavy};
  border: none;
  border-radius: 2px;
  padding: 0px;

  > div {
    color: white;
  }

  &:hover {
    background: ${colours.Core.CoreNavy};
    opacity: 0.5;
    > div {
      color: white;
    }
  }

  &:disabled,
  &[disabled] {
    background: ${colours.Greyscale.MistGrey};
    > div {
      color: ${colours.Greyscale.CharcoalGrey};
    }
  }
`;

export const StyledCtaButtons = styled(CtaButton)`
  margin: ${({ isMenuOpen }) => (isMenuOpen ? '6px' : '4px 0')};
  width: ${({ isMenuOpen }) => (isMenuOpen ? '95%' : '100%')};
`;

export const StyledMissingDetails = styled.div`
  background: ${colours.Greyscale.White};
  padding: 5px;
`;

export const ModalContents = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
